import { render } from "./StudyPhaseManagement.vue?vue&type=template&id=ed0d916c"
import script from "./StudyPhaseManagement.js?vue&type=script&lang=js"
export * from "./StudyPhaseManagement.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__